/**
 * A fitted card without its maker's display driver, or with one that did not answer (the engine's
 * WorkstationHealth.NoUsableCard reasons): the one fix the operator can make, so its advice is a known meaning
 * that Computer check shows and the remembered Speed boost result keeps. The product never installs a driver
 * itself. The advice is recognised as its own input too, so it survives the customer projection and a reload.
 */
export const driverAdvice = (reason: string): string | null => {
  if (/^Install (?:or repair )?the [A-Za-z ]+ display drivers?, then restart Paige\.$/.test(reason))
    return reason;
  const noDriver =
    /has no ((?:NVIDIA|AMD|Intel)(?: and (?:NVIDIA|AMD|Intel))*) display drivers? installed/.exec(
      reason,
    );
  if (noDriver)
    return `Install the ${noDriver[1]} display driver${noDriver[1].includes(' and ') ? 's' : ''}, then restart Paige.`;
  return /is fitted, but its display driver did not respond/.test(reason)
    ? 'Install or repair the NVIDIA display driver, then restart Paige.'
    : null;
};
